import { Delta, Op } from "quill" // Используйте вашу декларацию типа Delta, Op
import { QuillRef } from "./editor"

type MessageEntity = {
  type:
    | "bold"
    | "italic"
    | "strikethrough"
    | "spoiler"
    | "text_link"
    | "underline"
    | "code"
  offset: number
  length: number
  url?: string
}

export function deltaToMessageEntities(quill: QuillRef | undefined) {
  const text = quill?.current?.getText()
  const ops = quill?.current?.getContents().ops ?? []
  const entities: MessageEntity[] = []
  let offset = 0

  for (const op of ops) {
    const insert = typeof op.insert === "string" ? op.insert : " "
    // Telegram измеряет offset/length сущностей в UTF-16 code units,
    // а не в кодовых точках Unicode. `string.length` в JS как раз
    // возвращает число UTF-16 code units (эмодзи вне BMP = 2 единицы),
    // поэтому НЕ используем [...insert].length, который считает кодовые точки.
    const len = insert.length

    if (op.attributes) {
      for (const [attr, value] of Object.entries(op.attributes)) {
        let type: MessageEntity["type"] | null = null
        let url: string | undefined
        switch (attr) {
          case "bold":
            type = "bold"
            break
          case "italic":
            type = "italic"
            break
          case "strike":
            type = "strikethrough"
            break
          case "spoiler":
            type = "spoiler"
            break
          case "code":
            type = "code"
            break
          case "underline":
            type = "underline"
            break
          case "link":
            type = "text_link"
            url = typeof value === "string" ? value : undefined
            break
          default:
            break
        }
        if (type) {
          entities.push({
            type,
            offset,
            length: len,
            ...(url ? { url } : {}),
          })
        }
      }
    }
    offset += len
  }
  return { text, entities }
}
